module.exports = ".fa-download {\n    font-size: 14px;\n    color: #fff!important;\n    border-color: #018dad!important;\n    padding: 5px 6px;\n}\n.fa-download:hover {\n    color: #018dad !important;\n    border-color: #fff !important;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/collapsible-panel/collapsible-panel.component.css
// module id = ./src/app/shared/collapsible-panel/collapsible-panel.component.css
// module chunks = main